import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { PopoverController } from '@ionic/angular';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromPropertyProfileActions from '../../../store/actions/property-profile.actions';
import * as fromLayoutSelectors from '../../../store/selectors/layout.selectors';
import { CompassService } from '../../services/compass.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-search-menu',
  standalone: false,
  styleUrls: ['./search-menu.component.scss'],
  templateUrl: './search-menu.component.html'
})
export class SearchMenuComponent {
  private compassService = inject(CompassService);
  private popoverController = inject(PopoverController);
  private router = inject(Router);
  private store = inject(Store);

  useMobileLayout$: Observable<boolean>;
  isDeviceOrientationEnabled = false;

  constructor() {
    this.useMobileLayout$ = this.store.pipe(select(fromLayoutSelectors.selectUseMobileLayout));
  }

  async navigate(path: string[]) {
    await this.popoverController.dismiss();
    await this.router.navigate(path);
  }

  navigateToCamera() {
    return this.compassService.navigateToCameraView();
  }

  async navigateToHistory() {
    this.store.dispatch(fromPropertyProfileActions.loadProfileHistory({ payload: {} }));
    await this.navigate(['/property-search', 'history']);
  }
}
